export const SET_ASSIGN_ALL_BUTTON_CLICK = 'SET_ASSIGN_ALL_BUTTON_CLICK';
export const ADD_AUTO_ASSIGN_LIST = 'ADD_AUTO_ASSIGN_LIST';
export const SET_REVERT_CHANGES = 'SET_REVERT_CHANGES';
export const SET_REVERT_BUTTON = 'SET_REVERT_BUTTON';
export const SET_SAVE_BUTTON_CLICK = 'SET_SAVE_BUTTON_CLICK';
